// Register Style
import styled from "styled-components";

export const RegisterContainer = styled.div`
  width: 100%;
  text-align: center;
`;

export const RegisterImage = styled.img`
  width: 80%;
  padding: 3rem;
`;
